import { RECIPIENT_TYPE_SELF, REQ_ERROR, VALID_ERROR } from 'apps/auth/constants/Constants';
import { BANK_ACCOUNT } from 'apps/auth/constants/FieldType';
import { ERR_CARD_PARTNER_IS_DOWN } from 'apps/auth/constants/WellKnownErrorCodes';
import { clabeCalcChecksum } from 'apps/auth/helpers/utils';

interface SendField {
    name?: string;
    type?: string;
    value?: string;
    isError?: boolean;
    errorCode?: number;
    errorMessage?: string;
    [key: string]: unknown;
}

interface SendFieldsState {
    to_name: SendField;
    to_name_f: SendField;
}

interface SendToFieldsProps {
    toCountryId?: number;
    formName: string;
    messages: Record<string, string>;
    setFieldError: (formName: string, fieldName: string, message: string) => void;
    removeFieldError: (formName: string, fieldName: string) => void;
    fieldsObj: SendFieldsState;
    userName?: string;
    userLastName?: string;
    item: { value?: string; parentValue?: string };
    changeFormField: (formName: string, field: SendField) => void;
}

interface MessagesState {
    jsMessages?: Record<string, string>;
    pageMessages?: Record<string, string>;
    complexMessages?: Record<string, unknown>;
}

type OnBlurHandler = (account: string, name: string) => void;

export const getOnBlurHandler = (props: SendToFieldsProps, field: SendField = {}): OnBlurHandler | undefined => {
    if (field?.type === BANK_ACCOUNT) {
        return (account, name) => {
            if (props.toCountryId === 484) {
                const result = clabeCalcChecksum(account);
                if (!result) {
                    props.setFieldError(props.formName, name, props.messages[VALID_ERROR]);
                } else {
                    props.removeFieldError(props.formName, name);
                }
            } else if (!field.isError && typeof field?.errorCode === 'number' && field.errorCode !== 0) {
                props.removeFieldError(props.formName, name);
            }
        };
    }
    return undefined;
};

export const getFirstLastName = (props: SendToFieldsProps, typeOfTransfer?: string): void => {
    const updatedName: SendField = { ...props.fieldsObj.to_name };
    const updatedLastName: SendField = { ...props.fieldsObj.to_name_f };
    if (props.item.value === 'TRANSFER_FROM_SELF' || typeOfTransfer === RECIPIENT_TYPE_SELF) {
        updatedName.value = props.userName;
        updatedName.isReadOnly = true;
        updatedName.isError = false;
        updatedLastName.value = props.userLastName;
        updatedLastName.isReadOnly = true;
        updatedLastName.isError = false;
    } else if (props.item.parentValue === 'FAMILY_MAINTENANCE') {
        updatedName.isReadOnly = false;
        updatedLastName.isReadOnly = false;
    } else {
        updatedName.value = '';
        updatedName.isReadOnly = false;
        updatedLastName.value = '';
        updatedLastName.isReadOnly = false;
    }
    props.changeFormField('send', updatedName);
    props.changeFormField('send', updatedLastName);
};

export const getError = (field: SendField, messages: MessagesState): string | undefined => {
    if (field.errorCode === ERR_CARD_PARTNER_IS_DOWN) {
        return messages.pageMessages?.providerIsDown || field.errorMessage;
    }
    const errorMessageKey = field.value ? VALID_ERROR : REQ_ERROR;
    return field.errorMessage || messages.jsMessages?.[errorMessageKey];
};

export const isValueChanged = (visibleFields: SendField[], ref: { current?: SendField[] | null }): boolean => {
    let changed = false;
    if (ref.current) {
        visibleFields.forEach((f) => {
            if (changed) {
                return;
            }
            const refFiled = ref.current?.find((rf) => rf.name === f.name);
            changed = f?.value !== refFiled?.value;
        });
    }
    ref.current = visibleFields.slice();
    return changed;
};
